module.exports = __webpack_public_path__ + "media/images/design/images/btn_disaster-8369d20f86e8f4451f3f27a288b6420f.png";